import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../_services/AuthService.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  currentAction = "login";
  loggedIn = false;

  constructor(private _authService: AuthServiceService) { }

  ngOnInit() {
    this._authService.currentAction.subscribe(action => {
      this.loggedIn = this._authService.loggedIn();
    });
  }

  setAction(action) {
    this.currentAction = action;
  }

}
